import { theme } from '../..';
import { BarDatum, ResponsiveBar } from '@nivo/bar';

import { BarChartData } from '../../types';
import { NoData } from '../no-data';
import { getColor, getLabel, getTooltip } from './utils';

interface ProgressBarChartProps {
  data: BarChartData;
  sortByValue?: boolean;
}

export const ProgressBarChart = ({
  data = [],
  sortByValue = true,
}: ProgressBarChartProps) => {
  let sortedData = data;

  if (sortByValue) {
    sortedData = [...data].sort((a, b) => {
      if (typeof a.value === 'number' && typeof b.value === 'number') {
        return a.value - b.value;
      }
      return 0;
    });
  }

  const total_count = data.reduce((acc: any, curr: any) => acc + curr.value, 0);
  const dataWithRemainder: BarDatum[] = sortedData.map((d) => {
    return { ...d, remainder: total_count - d.value };
  });

  if (sortedData.length === 0) {
    return <NoData />;
  }

  return (
    <ResponsiveBar
      data={dataWithRemainder}
      theme={theme}
      keys={['value', 'remainder']}
      indexBy="category"
      margin={{ top: 32, right: 32, bottom: 32, left: 88 }}
      padding={0.25}
      innerPadding={1}
      layout="horizontal"
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={getColor}
      borderRadius={4}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisLeft={{
        tickSize: 0,
        tickPadding: 8,
        tickRotation: 0,
        legendPosition: 'middle',
        legendOffset: 0,
        truncateTickAt: 9,
      }}
      axisBottom={null}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={theme.textColor}
      label={getLabel(total_count)}
      tooltip={getTooltip(total_count)}
    />
  );
};